/* @flow */

import {
  notificationWarningLevel,
  notificationSuccessLevel,
  notificationTopType,
} from 'src/shared/app/notification/constant/notificationConstants';
import ModerationPostNotification from 'src/shared/app/moderation/component/ModerationPostNotification';
import ModerationAcceptedNotification from 'src/shared/app/moderation/component/ModerationAcceptedNotification';
import ModerationRejectedNotification from 'src/shared/app/moderation/component/ModerationRejectedNotification';
import ModerationAcceptedAndSlackNotification from 'src/shared/app/moderation/component/ModerationAcceptedAndSlackNotification';

export function convertModerationPostToNotification() {
  return {
    id: 'moderation-post-info',
    level: notificationWarningLevel,
    type: notificationTopType,
    componentClass: ModerationPostNotification,
  };
}

export function convertModerationAcceptedToNotification() {
  return {
    id: 'moderation-accepted',
    level: notificationSuccessLevel,
    type: notificationTopType,
    componentClass: ModerationAcceptedNotification,
  };
}

export function convertModerationRejectedToNotification() {
  return {
    id: 'moderation-rejected',
    level: notificationWarningLevel,
    type: notificationTopType,
    componentClass: ModerationRejectedNotification,
  };
}
export function convertModerationAcceptedAndSlackToNotification() {
  return {
    id: 'moderation-accepted-slack',
    level: notificationSuccessLevel,
    type: notificationTopType,
    componentClass: ModerationAcceptedAndSlackNotification,
  };
}
